// import moment from "moment"
import {EligibilityParams, getMembershipEligibilityData} from "./membershipEligibility"
import {postMembershipOAData, updateMembershipOAData, UserMembershipRequest} from "./oaMembership"

const saveUserMembershipInfo = async (request: UserMembershipRequest, membershipId?: number) => {
    // const INDEX = -4
    // const lastFourNric = request.user.nricFin.slice(INDEX)
    // const dob = moment(request.user.dob, `YYYY-MM-DD`).format(`DDMMYYYY`)
    let eligibilityParams: EligibilityParams | undefined = undefined
    if (request.user.occupationalGroup && request.user.occupation && request.user.company?.code) {
        eligibilityParams = {
            jobTitle: request.user.occupation,
            occupationGroupCode: request.user.occupationalGroup,
            companyCode: request.user.company.code,
        }
    }
    // const activeUser = await getMembershipActiveData(lastFourNric, dob)
    const eligibleUser = await getMembershipEligibilityData(request.user.nricFin, eligibilityParams)
    if (eligibleUser.length > 0 && eligibleUser[0].Checkclist === false && eligibleUser[0].Checkblist === false) {
        if (membershipId) {
            return updateMembershipOAData(request, membershipId)
        }
        return postMembershipOAData(request)
    }
}

export {saveUserMembershipInfo}